(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Zeta', Zeta)
		.factory('ZetaFecha', ZetaFecha); 

    Zeta.$inject = ['$resource', 'DateUtils'];
	ZetaFecha.$inject = ['$resource', 'DateUtils'];

    function Zeta ($resource, DateUtils) {
        var resourceUrl =  'api/zetas/:id';

        return $resource(resourceUrl, {}, {
			'queryByVenta': {
                url: 'api/zetas/ventas/:id',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechadesde = DateUtils.convertDateTimeFromServer(data.fechadesde);
                        data.fechahasta = DateUtils.convertDateTimeFromServer(data.fechahasta);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function ZetaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/zetafecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}


})();
